export default __webpack_public_path__ + "static/media/Background_00280.b6c9ffcc.png";